import { RequirePermission } from '@saniplus/ui';

import { PermissionFallback } from '../../../components/shared/PermissionFallback';

/**
 * Not a security control — the API answers on its own, and an out-of-scope read
 * is a 404 by design. This exists so the portal never offers a door that is
 * already locked, and it renders an explanation rather than redirecting: a
 * silent bounce to the dashboard reads as a broken link.
 */
export function ExceptionsGate() {
  return <RequirePermission permission="exception:read" fallback={<PermissionFallback />} />;
}
